// https://maskito.dev/addons/phone
export async function getPhoneMaskOpts () {
  const { maskitoPhoneOptionsGenerator } = await import("@maskito/phone")

  type MetadataJson =
    Parameters<typeof maskitoPhoneOptionsGenerator>[0]["metadata"]

  const metadata =
    (await import("libphonenumber-js/min/metadata") as
      { default: MetadataJson }).default

  return maskitoPhoneOptionsGenerator({
    metadata,
    strict: false,
    countryIsoCode: "RU",
  })
}
